import { useState, useEffect, useRef } from "react";
import "../../OperationMasterPages/ViewOrderDetails/ViewOrderDetails.css";
import React from "react";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import axios from "axios";
import Wrapper from "../../../components/UI/Wrapper";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import edit from "../../../images/edit.png";
import NoImage from "../../../images/no.png";
import reactangle from "../../../images/Rectangle 2404.png";
import nextstep from "../../../images/nextstep.png";
import { FaCheck } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";
import { SlNote } from "react-icons/sl";
import Loader from "../../../components/Loader/loader";
import Multiselect from "multiselect-react-dropdown";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import AddIcon from "@mui/icons-material/Add";
import search from "../../../images/Search.png";
import JSZip from "jszip";
import PaymentDetails from '../../../components/PaymentDetails/paymentDetails.jsx';
import ExecutionDOc from '../../../components/Execution&Documentation/executionDoc.jsx';
import LeadExpenseList from "../../../components/LeadExpenseList/LeadExpenseList";
import LeadExpenseListView from "../../../components/LeadExpenseListView/LeadExpenseListView";
import LeadPaymentDetails from "../../../components/LeadPaymentDetails/LeadPaymentDetails";


const ViewOrderDetails = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [leadDetailResponse, setLeadDetailResponse] = useState([]);
  const [petDetail, setPetDetail] = useState([]);
  const [relocationDetail, setRelocationDetail] = useState([]);
  const [orderUpdateList, setOrderUpdateList] = useState([]);
  const [assignToResponse, setAssignToResponse] = useState([]);
  const [fieldOpsResponse, setFieldOpsResponse] = useState([]);
  const isAdmin = localStorage.getItem("isAdmin");
  const gradientColors = ["#F15843", "#A3519F", "#5B489D"];
  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const [decryptionError, setDecryptionError] = useState(false);
  const [vaccinationBookFront, setVaccinationBookFront] = useState(null);
  const [vaccinationBookBack, setVaccinationBookBack] = useState(null);
  const [petPhotosSitting, setPetPhotosSitting] = useState(null);
  const [petPhotosStanding, setPetPhotosStanding] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [orderStatus, setOrderStatus] = useState([]);
  const [relocationStage, setRelocationStage] = useState([]);
  const [relocationSubStage, setRelocationSubStage] = useState([]);
  const [orderStatusString, setOrderStatusString] = useState(null);
  const [relocationStageString, setRelocationStageString] = useState(null);
  const [relocationSubStageString, setRelocationSubStageString] =
    useState(null);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [documentType, setDocumentType] = useState([]);
  const [documentResponse, setDocumentResponse] = useState(null);
  const fileInputRef = useRef(null);

  const searchParams = new URLSearchParams(location.search);
  const encryptedRelocationID = searchParams.get("Relocation_ID");
  const Relocation_ID = decryptRelocationID(encryptedRelocationID);
  // My new code
  const [activeTab, setActiveTab] = useState("Order Details");
  const tabs = ["Order Details", "Payment Details", "Scope Of Work", "Execution & Documentation", "Expense List"];
  const tabRefs = useRef([]); // To store refs for each tab
  const [indicatorStyle, setIndicatorStyle] = useState({});
  const tabContainerRef = useRef(null);
  const [showExpenseModal, setShowExpenseModal] = useState(false);
  const [estimateDetail, setEstimateDetail] = useState([]);
  const goToAddExpense = () => {
    setShowExpenseModal(true);
  };

  const closeExpenseModal = () => {
    setShowExpenseModal(false);
  };

  const [showPettyCashModal, setShowPettyCashModal] = useState(false);
  const [expenseType, setExpenseType] = useState([]);
  const [pettyCashForm, setPettyCashForm] = useState({
    relocation_id: Relocation_ID,
    request_type: "",
    amount: "",
    remark: "",
    approval_status: "Requested"
  });



  // My New Code End

  const [fieldOps, setFieldOps] = useState([]);
  const now = new Date();
  const [orderUpdate, setOrderUpdate] = useState({
    relocation_id: "",
    NextFollowupDateTime: "",
    order_status: "",
    relocation_stage: "",
    assignTo: "",
    staffView: "",
    remark: "",
    assign_to_field_ops: "",
    relocation_substage: "",
  });

  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc"); // Default sort order is ascending

  const sortAndToggleOrder = (column) => {
    // Determine the new sort order
    const newSortOrder =
      sortedColumn !== column || sortOrder === "desc" ? "asc" : "desc";

    let sortedData = [...documentResponse];
    // Sorting logic here (adjusted to use newSortOrder)
    if (column === "document_type") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    }
    setDocumentResponse(sortedData);
    setSortedColumn(column);
    setSortOrder(newSortOrder);
  }

  const handleChange = (e) => {
    const { name, value } = e.target;

    const executionDate = new Date(orderDetail.relocation_date);

    if (name === "order_status" && value === "2" && executionDate > now) {
      alert("Cannot select 'Executed' if Execution Date is in the future.");
      return;
    }

    if (name === "relocation_stage") {
      getRelocationSubStage(0, value);
    }

    setOrderUpdate((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const [selectedAssignedTo, setSelectedAssignedTo] = useState([]);

  const onSelect = (selectedList, selectedItem) => {
    setSelectedAssignedTo(selectedList);
    const selectedTypes = selectedList
      .map((item) => item.name?.trim())
      .filter((name) => !!name) // removes empty strings/null/undefined
      .join(", ");
    setOrderUpdate((prevState) => ({
      ...prevState,
      assign_to_field_ops: selectedTypes,
    }));
  };

  const onRemove = (selectedList, removedItem) => {
    setSelectedAssignedTo(selectedList);
    const selectedTypes = selectedList
      .map((item) => item.name?.trim())
      .filter((name) => !!name)
      .join(", ");
    setOrderUpdate((prevState) => ({
      ...prevState,
      assign_to_field_ops: selectedTypes,
    }));
  };

  const [orderDetail, setOrderDetail] = useState({
    relocation_id: "",
    sender_alternate_no: "",
    sender_alternate_email: "",
    receiver_alternate_no: "",
    receiver_alternate_email: "",
    airline_train_name: "",
    airline_train_number: "",
    departure_time: "",
    arrival_time: "",
    origin_address: "",
    destination_address: "",
    origin_pin: "",
    destination_pin: "",
    origin_contact_person: "",
    destination_contact_person: "",
    sender_contact_no: "",
    receiver_contact_no: "",
    pick_up_distance: "",
    drop_distance: "",
    relocation_date: "",
    awb_number: "",
  });

  const [documentsUpload, setDocumentsUpload] = useState({
    client_doc_id: "",
    relocation_id: "",
    document_type: "",
    remarkDoc: "",
    doc_path: "",
    doc_name: "",
    priority_upload: "1",
  });

  const handleODChange = (e) => {
    const { name, value } = e.target;
    setOrderDetail((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  function isValidFileType(file) {
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
      "application/vnd.ms-excel", // XLS
      "video/mp4",
      "video/x-msvideo", // AVI
      "video/x-matroska", // MKV
      "video/quicktime", // MOV
      "application/zip", // ZIP
      "application/x-zip-compressed", // Alternate ZIP MIME type
    ];
    return file && allowedTypes.includes(file.type);
  }

  function getUpdatedImage(file, name) {
    if (file) {
      setDocumentsUpload({
        ...documentsUpload,
        [name]: file, // Store the file object directly
      });
    }
  }

  function validateZipFile(file, name, e) {
    const reader = new FileReader();
    reader.onload = function (event) {
      const zipData = event.target.result;

      // Perform ZIP content validation here
      // This might include extracting the files, verifying file types, etc.
      // Client-side libraries like JSZip can help inspect ZIP files
      try {
        const jszip = new JSZip();
        jszip.loadAsync(zipData).then((zip) => {
          const allowedExtensions = ["jpg", "png", "pdf", "docx", "xlsx"];
          let isValid = true;

          zip.forEach((relativePath, zipEntry) => {
            const extension = relativePath.split(".").pop().toLowerCase();
            if (!allowedExtensions.includes(extension)) {
              isValid = false;
            }
          });

          if (isValid) {
            getUpdatedImage(file, name);
          } else {
            alert("ZIP file contains unsupported file types.");
            e.target.value = null;
          }
        });
      } catch (error) {
        alert("Error reading ZIP file.");
        e.target.value = null;
      }
    };

    reader.readAsArrayBuffer(file);
  }




  function handleChangeDoc(e) {
    const { name, value, files } = e.target;

    if (name === "doc_name") {
      const file = files[0];
      if (file.size > 50 * 1024 * 1024) {
        alert("File size exceeds 50 MB limit.");
        e.target.value = null;
        return;
      }

      if (isValidFileType(file)) {
        if (file.type === "application/zip" || file.type === "application/x-zip-compressed") {
          validateZipFile(file, name, e);
        } else {
          getUpdatedImage(file, name);
        }
      } else {
        alert("Unsupported file type. Please upload a valid file.");
        // Reset the file input field
        e.target.value = null;
        return;
      }
    } else {
      setDocumentsUpload({
        ...documentsUpload,
        [name]: value,
      });
    }
  }

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);
      setDecryptionError(true);

      return null;
    }
  }

  function getEmployeeByDepartment(dept_id) {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(
        `${baseAPI}adminget/GETEmployeeByDepartment?department_id=` + dept_id,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      )
      .then((response) => {
        if (dept_id == 9) {
          setAssignToResponse(response.data.data);
        }
        if (dept_id == 12) {
          setFieldOpsResponse(response.data.data);
          const options = response.data.data.map((item) => ({
            id: item.name,
            name: item.name,
          }));
          setFieldOps(options);
        }
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getOrderStatus() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(`${baseAPI}adminget/GETOrderStatus`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setOrderStatus(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getRelocationStage() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(`${baseAPI}adminget/GETRelocationStage`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setRelocationStage(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getRelocationSubStage(substage_id, stage_id) {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(
        `${baseAPI}adminget/GETRelocationSubStage?substage_id=` +
        substage_id +
        `&stage_id=` +
        stage_id,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      )
      .then((response) => {
        setRelocationSubStage(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  const checkRequired = () => {

    const fields2 = [
      "origin_address",
      "destination_address",
      "origin_contact_person",
      "destination_contact_person",
      "sender_contact_no",
      "receiver_contact_no",
      "departure_time",
      "arrival_time"
    ]
    const petFields = [
      // "pet_age",
      // "pet_dob",
      // "pet_gender",
      // "pet_name"
    ];

    const fields = [
      // "assign_to_field_ops",

      "order_status",
      "assignTo",
      "relocation_stage",
      "relocation_substage",
      "remark"
    ];

    for (const field of fields) {
      const value = orderUpdate[field];
      const nextfollowupdatetime = orderUpdate.NextFollowupDateTime;
      if (orderUpdate.order_status === "executed" && !nextfollowupdatetime) {
        continue;
      }
      if (
        value === undefined || value === null || value === 0 ||
        (typeof value === "string" &&
          (value.trim() === "" || value.trim() === "0"))
      ) {
        alert(`Please provide ${field.replace("_", " ")}!!`);
        return false;
      }
    }

    if (isAdmin === "true") {
      if (!fieldOps || fieldOps.length === 0) {
        alert("Please select at least one Field Ops!");
        return false;
      }
    }

    return true;

  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!checkRequired()) {
      return;
    }

    if (orderUpdate.order_status === 2 || orderUpdate.order_status === "2") {
      const proceed = window.confirm("Hope you have uploaded all the expenses. Do you want to proceed?");
      if (!proceed) {
        return;
      }
    }

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}userpost/AddOrderUpdateDetail`,
        orderUpdate,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      const response1 = await axios.post(
        `${baseAPI}userpost/AddOrderDetail`,
        orderDetail,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      setSuccessMessage("Data successfully saved");
      window.location.reload();
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const uploadDocument = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);

    // Append form fields and the file to FormData
    formData.append("relocation_id", Relocation_ID);
    formData.append("document_type", documentsUpload.document_type);
    formData.append("remarkDoc", documentsUpload.remarkDoc);
    formData.append("priority_upload", 1);

    // Ensure the file itself is being sent
    formData.append("doc_name", documentsUpload.doc_name); // This will now be the file object

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}userpost/UploadClientPdfData`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "multipart/form-data", // Ensure you're sending form data
          },
        }
      );

      // Reset after success
      setDocumentsUpload({
        relocation_id: "",
        document_type: "",
        remarkDoc: "",
        doc_path: "",
        doc_name: "",
        priority_upload: "1",
      });

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      getDocument(Relocation_ID);
    } catch (error) {
      console.error("Error posting data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Function for document submission
  async function submitDocument(client_doc_id) {

    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}userpost/SubmitClientDocument`,
        { client_doc_id: client_doc_id },
        {
          // Send request body
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      getDocument(Relocation_ID);
    }
    catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }

  }

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
    setButtonClicked(!buttonClicked); // Toggle button color on click


  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);

    setOrderUpdate((prevItem) => ({
      ...prevItem,
      relocation_id: Relocation_ID,
    }));

    setOrderDetail((prevItem) => ({
      ...prevItem,
      relocation_id: Relocation_ID,
    }));

    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetLeadOptDetail?relocation_id=` + Relocation_ID,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setLeadDetailResponse(response.data.data);
          setRelocationDetail(response.data.data.relocationdetail[0]);
          setPetDetail(response.data.data.petsDetail[0]);
          setOrderUpdateList(response.data.data.orderupdatedetail);
          if (
            response.data.data.orderdetail != null &&
            response.data.data.orderdetail.length > 0
          ) {
            setOrderDetail(response.data.data.orderdetail[0]);
          }

          setOrderDetail((prevItem) => ({
            ...prevItem,
            relocation_date: response.data.data.relocationdetail[0].relocation_date,
          }));


          getEmployeeByDepartment(9);
          getEmployeeByDepartment(12);
          getOrderStatus();
          getRelocationStage();
          //getRelocationSubStage(0, 0);
          getDocumentTypeName(response.data.data.service_type);

          setVaccinationBookFront(
            `${baseImageURL}${response.data.data.petsDetail[0].vaccinationbook_front}`
          );
          setVaccinationBookBack(
            `${baseImageURL}${response.data.data.petsDetail[0].vaccinationbook_back}`
          );
          setPetPhotosSitting(
            `${baseImageURL}${response.data.data.petsDetail[0].pet_photo_standing}`
          );
          setPetPhotosStanding(
            `${baseImageURL}${response.data.data.petsDetail[0].pet_photo_sitting}`
          );

          if (
            response.data.data.orderupdatedetail != null &&
            response.data.data.orderupdatedetail.length > 0
          ) {
            setRelocationStageString(
              response.data.data.orderupdatedetail[0].relocation_stage_name
            );
            setRelocationSubStageString(
              response.data.data.orderupdatedetail[0].sub_stage_name
            );
            setOrderStatusString(
              response.data.data.orderupdatedetail[0].order_status_name
            );
            setOrderUpdate({
              relocation_id:
                response.data.data.orderupdatedetail[0].relocation_id || "",
              NextFollowupDateTime:
                response.data.data.orderupdatedetail[0].NextFollowupDateTime ||
                "",
              order_status:
                response.data.data.orderupdatedetail[0].order_id || 0,
              relocation_stage:
                response.data.data.orderupdatedetail[0].relocation_stage_id ||
                0,
              assignTo: response.data.data.orderupdatedetail[0].assignTo || "",
              staffView:
                response.data.data.orderupdatedetail[0].staffView || "",
              remark: response.data.data.orderupdatedetail[0].remark || "",
              assign_to_field_ops:
                response.data.data.orderupdatedetail[0].assign_to_field_ops ||
                "",
              relocation_substage:
                response.data.data.orderupdatedetail[0].relocation_substage ||
                0,
            });
            getRelocationSubStage(0, response.data.data.orderupdatedetail[0].relocation_stage_id);
            const selectedValues =
              response.data.data.orderupdatedetail[0].assign_to_field_ops
                .split(",")
                .map((item) => {
                  return (
                    fieldOps.find((op) => op.name.trim() === item.trim()) || {
                      name: item.trim(),
                    }
                  );
                });
            setSelectedAssignedTo(selectedValues);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });

      axios
        .get(
          `${baseAPI}userget/GetClientDocuments?relocation_id=` +
          Relocation_ID +
          `&option=3`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setDocumentResponse(response.data.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });

      axios
        .get(`${baseAPI}Userget/EstimateListDetaile?search_param=${Relocation_ID}&Status=-1`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setEstimateDetail(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });


      axios
        .get(`${baseAPI}adminget/GetRequestType`, {  // adjust endpoint as needed
          headers: { Authorization: `Bearer ${storedToken}` },
        })
        .then((response) => setExpenseType(response.data.data))
        .catch((error) => console.error("Error fetching expense types:", error));


    }

    // My new Code
    // Update tab indicator styles
    const updateIndicatorStyles = () => {
      const currentTabIndex = tabs.indexOf(activeTab);
      const currentTabRef = tabRefs.current[currentTabIndex];

      if (currentTabRef) {
        // Adjust offset to correct for extra padding/margins
        const containerOffset = tabContainerRef.current.offsetLeft || 0;

        setIndicatorStyle({
          width: `${currentTabRef.offsetWidth}px`,
          transform: `translateX(${currentTabRef.offsetLeft - containerOffset}px)`,
        });
      }
    };
    // My new Code End
    updateIndicatorStyles();
  }, [activeTab, location.search]);


  function getDocumentTypeName(typeId) {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}userget/GetDocumentType?service_type=` + typeId + `&user_type=1`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          if (response) {
            setDocumentType(response.data.data.map((Name) => ({ Name })));
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  function getDocument(Relocation_ID) {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetClientDocuments?relocation_id=` +
          Relocation_ID +
          `&option=3`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setDocumentResponse(response.data.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  const searchWrapper1 = {
    border: "none !important",
    borderRadius: "4px",
    minHeight: "22px",
    padding: "5px 5px 5px 8px",
    position: "relative",
    width: "24rem",
  };

  const inputStyle = {
    width: "100%",
    padding: "8px",
    marginBottom: "10px",
    border: "1px solid #ddd",
    borderRadius: "4px",
  };

  async function deleteDoc(client_doc_id) {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this document?"
    );
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);
    if (isConfirmed) {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.delete(
        `${baseAPI}userpost/DeleteClientDocs`,
        {
          data: { client_doc_id: client_doc_id }, // Send request body
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      getDocument(Relocation_ID);
    }
  }

  const navigate = useNavigate();
  function orderListPage() {
    navigate("/orderlist");
  }

  useEffect(() => {
    if (
      assignToResponse?.length > 0 &&
      leadDetailResponse?.Assigned_By_Coordinator
    ) {
      const coordinatorName = leadDetailResponse.Assigned_By_Coordinator.trim();

      const matchedUser = assignToResponse.find((user) => {
        return user.name?.trim() === coordinatorName;
      });

      if (matchedUser) {
        setOrderUpdate((prev) => ({
          ...prev,
          assignTo: matchedUser.email,
        }));
      }
    }
  }, [assignToResponse, leadDetailResponse]);

  const handleAWBChange = (e) => {
    const newValue = e.target.value;

    // Update leadDetailResponse
    setLeadDetailResponse((prev) => ({
      ...prev,
      awb_number: newValue,
    }));

    // Update orderDetail
    setOrderDetail((prev) => ({
      ...prev,
      awb_number: newValue,
    }));
  };

  const ChangeLeadOwner = async (e) => {
    e.preventDefault();
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint

      const response = await axios.post(
        `${baseAPI}userpost/UpdateLeadCoordinator`,
        orderUpdate, // Send firstItem as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      window.location.reload();
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  const goToPettyCash = () => {
    setPettyCashForm({ relocation_id: Relocation_ID, request_type: "", amount: "", remark: "", approval_status: "Requested" });
    setShowPettyCashModal(true);
  };

  const closePettyCashModal = () => setShowPettyCashModal(false);

  const handleAddPettyCash = async () => {
    if (!pettyCashForm.request_type || !pettyCashForm.amount) {
      alert("Please fill in Request Type and Amount.");
      return;
    }
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      await axios.post(
        `${baseAPI}userpost/InsertUpdateCmpPettyCash`,   // adjust endpoint as needed
        pettyCashForm,
        { headers: { Authorization: `Bearer ${storedToken}` } }
      );
      alert("Petty cash request submitted successfully.");
      closePettyCashModal();
    } catch (error) {
      console.error("Error submitting petty cash:", error);
    }
  };


  const labelStyle = {
    fontSize: "12px", color: "#6A6A6A", fontWeight: "500",
    display: "block", marginBottom: "5px",
    textTransform: "uppercase", letterSpacing: "0.4px",
  };

  const fieldStyle = {
    width: "100%", height: "38px",
    border: "1px solid #D0D5DD", borderRadius: "6px",
    padding: "0 10px", fontSize: "14px", color: "#1a1a1a",
    backgroundColor: "#fff", outline: "none",
  };

  const cancelBtnStyle = {
    height: "38px", padding: "0 22px", borderRadius: "6px",
    fontSize: "14px", fontWeight: "500", cursor: "pointer",
    border: "1px solid #D0D5DD", background: "#fff", color: "#555",
  };

  const addBtnStyle = {
    height: "38px", padding: "0 22px", borderRadius: "6px",
    fontSize: "14px", fontWeight: "500", cursor: "pointer",
    border: "none", background: "#5B489D", color: "#fff",
  };


  return (
    <div>
      <div className="app-container-viewLeadDetails">
        <MiniDrawer />
        <div className="container-fluid container-viewLeadDetails">
          <div className="country-header" style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1rem",
          }}>
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                <b> View Order Details </b> | <HomeOutlinedIcon /> &gt;
                <a style={{ cursor: "pointer" }}>
                  <span style={{ fontSize: "20px" }} onClick={orderListPage}>
                    Order List{" "}
                  </span>
                </a>
                <span style={{ fontSize: "20px" }}>
                  &gt; View Order Details
                </span>
              </h1>
            </div>
            <div style={{ backgroundColor: "#682465" }}>
              <h5
                style={{
                  color: "white",
                  fontSize: "16px",
                  padding: "10px",
                }}
              >
                Lead Id: {leadDetailResponse.relocation_id}
              </h5>
            </div>
          </div>
          <Wrapper className="OrderDetails">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1
                  style={{
                    fontSize: "24px",
                    padding: "17px 0 0 28px",
                    fontWeight: "700",
                  }}
                >
                  {`${leadDetailResponse?.lead_region || ""}, ${relocationDetail?.delivery_type_name || ""
                    }, ${leadDetailResponse.JobType}`}
                </h1>
              </div>

              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {estimateDetail.length > 0 && (

                  <button
                    className="btn btn-primary btn-primary-estimate"
                    style={{
                      margin: "5px 10px 5px 0px",
                      backgroundColor: estimateDetail?.[0]?.estimate_attachment ? "white" : "#f0f0f0",
                      color: estimateDetail?.[0]?.estimate_attachment ? "#6A6A6A" : "#a0a0a0",
                      borderColor: "#C0C6CC",
                      whiteSpace: "nowrap",
                      width: "auto",
                      cursor: estimateDetail?.[0]?.estimate_attachment ? "pointer" : "not-allowed",
                    }}
                    disabled={!estimateDetail?.[0]?.estimate_attachment}
                    onClick={() => {
                      if (estimateDetail?.[0]?.estimate_attachment) {
                        window.open(`${baseImageURL}Images/Documents/${leadDetailResponse.relocation_id}/${estimateDetail[0].estimate_attachment}`, "_blank");
                      }
                    }}
                  >
                    QUOTATION - {estimateDetail[0].finalAfterGateway}
                  </button>

                )}

                <button
                  onClick={goToPettyCash}
                  className="btn btn-primary"
                  style={{
                    margin: "5px 10px 5px 0px",
                    backgroundColor: "white",
                    color: "#6A6A6A",
                    borderColor: "#C0C6CC",
                    height: "53px",
                    width: "13rem",
                  }}
                >
                  <AddIcon className="icon" />
                  Request Petty Cash
                </button>
                {showPettyCashModal && (
                  <div style={{
                    position: "fixed", top: 0, left: 0,
                    width: "100vw", height: "100vh",
                    backgroundColor: "rgba(0,0,0,0.45)",
                    zIndex: 9999,
                    display: "flex", alignItems: "center", justifyContent: "center",
                  }}>
                    <div style={{
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                      width: "640px",
                      overflow: "hidden",
                    }}>

                      {/* Header */}
                      <div style={{
                        backgroundColor: "#5B489D",
                        padding: "14px 20px",
                        display: "flex", alignItems: "center", justifyContent: "space-between",
                      }}>
                        <span style={{ color: "#fff", fontSize: "15px", fontWeight: "600" }}>
                          Add Petty Cash Request
                        </span>
                        <button onClick={closePettyCashModal} style={{
                          background: "transparent", border: "none",
                          color: "rgba(255,255,255,0.85)", fontSize: "22px",
                          cursor: "pointer", lineHeight: 1,
                          width: "28px", height: "28px",
                          display: "flex", alignItems: "center", justifyContent: "center",
                          borderRadius: "4px",
                        }}>&times;</button>
                      </div>

                      {/* Body */}
                      <div style={{ padding: "20px 24px" }}>

                        {/* Row 1 */}
                        <div style={{
                          display: "grid", gridTemplateColumns: "1fr 1fr 1fr",
                          gap: "14px", marginBottom: "14px",
                        }}>
                          {[
                            {
                              label: "Lead ID", content: (
                                <input type="number"
                                  value={pettyCashForm.relocation_id}
                                  disabled
                                  style={fieldStyle} />
                              )
                            },
                            {
                              label: "Request Type", content: (
                                <select value={pettyCashForm.request_type}
                                  onChange={(e) => setPettyCashForm({ ...pettyCashForm, request_type: parseInt(e.target.value) })}
                                  style={fieldStyle}>
                                  <option value="">Select type</option>
                                  {expenseType.map((exp) => (
                                    <option key={exp.request_type_id} value={exp.request_type_id}>
                                      {exp.request_type}
                                    </option>
                                  ))}
                                </select>
                              )
                            },
                            {
                              label: "Amount (₹)", content: (
                                <input type="number" placeholder="0"
                                  value={pettyCashForm.amount}
                                  onChange={(e) => setPettyCashForm({ ...pettyCashForm, amount: e.target.value })}
                                  style={fieldStyle} 
                                  onWheel={(e) => e.target.blur()}
                                  />
                              )
                            },
                          ].map(({ label, content }) => (
                            <div key={label}>
                              <label style={labelStyle}>{label}</label>
                              {content}
                            </div>
                          ))}
                        </div>

                        {/* Remark */}
                        <div style={{ marginBottom: "18px" }}>
                          <label style={labelStyle}>Remark</label>
                          <textarea rows={2} placeholder="Remark (Optional)"
                            value={pettyCashForm.remark}
                            onChange={(e) => setPettyCashForm({ ...pettyCashForm, remark: e.target.value })}
                            style={{ ...fieldStyle, height: "auto", padding: "9px 10px", resize: "none" }} />
                        </div>

                        {/* Footer */}
                        <div style={{
                          display: "flex", justifyContent: "flex-end", gap: "10px",
                          borderTop: "1px solid #f0f0f0", paddingTop: "14px",
                        }}>
                          <button onClick={closePettyCashModal} style={cancelBtnStyle}>Cancel</button>
                          <button onClick={handleAddPettyCash} style={addBtnStyle}>Add Request</button>
                        </div>

                      </div>
                    </div>
                  </div>
                )}

                <button onClick={goToAddExpense}
                  className="btn btn-primary"
                  style={{
                    margin: "5px 10px 5px 0px", //
                    backgroundColor: "white",
                    color: "#6A6A6A",
                    borderColor: "#C0C6CC",
                    height: "53px",
                    width: "154px", //
                  }}
                >
                  ADD EXPENSE
                </button>



                {showExpenseModal && (
                  <div className="modal-overlay">
                    <div className="modal-content" style={{ maxWidth: "1000px" }}>
                      <button className="close-button leadExpenseListMswork" onClick={closeExpenseModal}>X</button>
                      <LeadExpenseList relocationId={Relocation_ID} onClose={closeExpenseModal} />
                    </div>
                  </div>
                )}

                {relocationSubStageString !== "File submitted to the finance" && (
                  <button
                    className={
                      isEditMode
                        ? "btn btn-primary edit-Button-on"
                        : "btn btn-primary edit-Button-off"
                    }
                    onClick={toggleEditMode}
                    style={{
                      margin: "5px 30px 5px 0px",
                      backgroundColor: buttonClicked
                        ? "rgba(160, 22, 22, .247)"
                        : "white",
                      color: buttonClicked ? "white" : "#6A6A6A",
                      borderColor: "#C0C6CC",
                      height: "53px",
                      width: "154px",
                    }}
                  >
                    EDIT
                  </button>
                )}
              </div>
            </div>
          </Wrapper>
          <br />
          {/* My Chnage code */}

          <div className="tabs" ref={tabContainerRef}>
            {tabs.map((tab, index) => (
              <span
                key={tab}
                ref={(el) => (tabRefs.current[index] = el)}
                className={`tab ${activeTab === tab ? "active" : ""}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </span>
            ))}
          </div>
          <hr className="hr-mychange" />
          <div
            className="tab-indicator"
            style={indicatorStyle} // Apply dynamic styles here
          ></div>



          {/* My change code end */}

          {activeTab === "Order Details" && (

            <div>
              {/* ------------------------lead deatil--------------------- */}
              <div>
                <Wrapper className="Orderdetails">
                  {/* ------------------------Customer deatil--------------------- */}
                  <div className="viewOrderDetails-form">
                    {/* My New Code Customer deatil*/}
                    <div className="Petment-Details1" style={{ display: "flex", flexDirection: "row" }}><h3 class="order-summary-title">Customer Details</h3></div>

                    <div className="viewOrderDetails-form">
                      <table
                        style={{
                          width: "100%",
                          color: "#6A6A6A",
                          borderRadius: "5px",
                        }}
                      >
                        <tr className="viewLeadDetailsHeading PaymentDetailsHeading">
                          <th>
                            <span>Full Name</span>
                          </th>
                          <td>
                            <span>{leadDetailResponse.first_name}</span>
                          </td>
                          <th>
                            <span>Email Id</span>
                          </th>
                          <td>
                            <span>
                              {leadDetailResponse.email}
                            </span>
                          </td>
                        </tr>

                        <tr className="viewLeadDetailsHeading PaymentDetailsHeading">
                          <th>
                            <span>Contact Number</span>
                          </th>
                          <td>
                            <span>{leadDetailResponse.mobile_no}</span>
                          </td>
                          <th>
                            <span>Alternate Contact Number</span>
                          </th>
                          <td>
                            <span>{leadDetailResponse.alternate_number}</span>
                          </td>
                        </tr>

                        <tr className="viewLeadDetailsHeading PaymentDetailsHeading">
                          <th>
                            <span>Address</span>
                          </th>
                          <td>
                            <span>
                              { }
                            </span>
                          </td>
                          <th>
                            <span>City</span>
                          </th>
                          <td>
                            <span>{relocationDetail.origin_city1}</span>
                          </td>
                        </tr>
                        <tr className="viewLeadDetailsHeading PaymentDetailsHeading">
                          <th>
                            <span>State</span>
                          </th>
                          <td>
                            <span>
                              {relocationDetail.origin_state1}
                            </span>
                          </td>
                          <th>
                            <span>Pin Code</span>
                          </th>
                          <td>
                            <span>{relocationDetail.origin_pin}</span>
                          </td>
                        </tr>
                      </table>
                    </div>
                    {/* My New Code Customer deatil end */}

                    {/* My New Code Order deatil */}
                    <div className="Petment-Details1" style={{ display: "flex", flexDirection: "row" }}><h3 class="order-summary-title">Order Details</h3></div>

                    <div className="viewOrderDetails-form">
                      <table
                        style={{
                          width: "100%",
                          color: "#6A6A6A",
                          borderRadius: "5px",
                        }}
                      >
                        <tr className="viewLeadDetailsHeading PaymentDetailsHeading">
                          <th>
                            <span>Lead Id</span>
                          </th>
                          <td>
                            <span>{leadDetailResponse.relocation_id}</span>
                          </td>
                          <th>
                            <span>Execution Date</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                style={{ margin: "0px", ...inputStyle }}
                                className="form-control"
                                type="date"
                                name="relocation_date"
                                placeholder="Please Enter*"
                                onChange={handleODChange}
                                value={orderDetail.relocation_date ? new Date(orderDetail.relocation_date).toLocaleDateString("en-CA") : ""}
                                max={orderUpdate.order_status === "2" ? new Date().toISOString().split("T")[0] : ""}
                              />
                            ) : (
                              <span>
                                {new Date(
                                  relocationDetail.relocation_date
                                ).toLocaleString("en-US", {
                                  month: "short", // Oct
                                  day: "numeric", // 23
                                  year: "numeric", // 2024
                                  hour: "numeric", // 11
                                  minute: "numeric", // 22
                                  hour12: true, // AM/PM format
                                })}
                              </span>
                            )}
                          </td>
                        </tr>

                        <tr className="viewLeadDetailsHeading PaymentDetailsHeading">
                          <th>
                            <span>Service Type</span>
                          </th>
                          <td>
                            <span>{leadDetailResponse.servicetypename}</span>
                          </td>
                          <th>
                            <span>Lead Type</span>
                          </th>
                          <td>
                            <span>{relocationDetail.lead_region} </span>
                          </td>
                        </tr>

                        <tr className="viewLeadDetailsHeading PaymentDetailsHeading">
                          <th>
                            <span>Delivery Type</span>
                          </th>
                          <td>
                            <span>
                              {relocationDetail.delivery_type_name}
                            </span>
                          </td>
                          <th>
                            <span>Payment Status</span>
                          </th>
                          <td>
                            <span>{ }</span>
                          </td>
                        </tr>
                        <tr className="viewLeadDetailsHeading PaymentDetailsHeading">
                          <th>
                            <span>Entry Date & Time</span>
                          </th>
                          <td><span>
                            {new Date(leadDetailResponse.entry_date).toLocaleString(
                              "en-US",
                              {
                                month: "short", // Oct
                                day: "numeric", // 23
                                year: "numeric", // 2024
                                hour: "numeric", // 11
                                minute: "numeric", // 22
                                hour12: true, // AM/PM format
                              }
                            )}</span>
                          </td>
                          <th>
                            <span>Update Date & Time</span>
                          </th>
                          <td><span>
                            {new Date(leadDetailResponse.updated_date).toLocaleString(
                              "en-US",
                              {
                                month: "short", // Oct
                                day: "numeric", // 23
                                year: "numeric", // 2024
                                hour: "numeric", // 11
                                minute: "numeric", // 22
                                hour12: true, // AM/PM format
                              }
                            )}</span>
                          </td>
                        </tr>
                        <tr className="viewLeadDetailsHeading PaymentDetailsHeading">
                          <th>
                            <span>Lead Owner</span>
                          </th>
                          <td>
                            <span>
                              {leadDetailResponse.name}
                            </span>
                          </td>
                          <th>
                            <span>Assigned To</span>
                          </th>
                          <td>
                            <span>{leadDetailResponse.Assigned_By_Coordinator}</span>
                          </td>
                        </tr>
                        <tr className="viewLeadDetailsHeading PaymentDetailsHeading">
                          <th>
                            <span>Previously Assigned To</span>
                          </th>
                          <td>
                            <span>
                              { }
                            </span>
                          </td>
                          <th>
                            <span>Field Ops Co-ordinator</span>
                          </th>
                          <td>
                            <span>{orderUpdate.assign_to_field_ops}</span>
                          </td>
                        </tr>
                      </table>
                    </div>
                    {/* My New Code Order deatil end */}



                    {/* Relocation Details */}
                    <div className="viewLeadDetails-form">
                      <table
                        style={{
                          width: "100%",
                          color: "#6A6A6A",
                          borderRadius: "5px",
                        }}
                      >
                        <tr className="viewLeadDetailsHeading">
                          <th
                            colSpan={4}
                            style={{
                              background: "#5B489D",
                              color: "white",
                              fontWeight: "bold",
                              borderRadius: "2px 2px 2px 2px",
                            }}
                          >
                            <span style={{ fontSize: "18px" }}>
                              {" "}
                              Relocation Details{" "}
                            </span>
                          </th>
                        </tr>
                        <tr
                          className="viewLeadDetailsHeading"
                          style={{ height: "3px" }}
                        >
                          <td
                            colSpan={4}
                            style={{
                              background: "#ffffff",
                            }}
                          ></td>
                        </tr>
                        <tr className="viewLeadDetailsHeading">
                          <th
                            colSpan={2}
                            style={{
                              background: "#A3519F",
                              color: "white",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            <span style={{ fontSize: "16px" }}> From </span>
                          </th>

                          <th
                            colSpan={2}
                            style={{
                              background: "#A3519F",
                              color: "white",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            <span style={{ fontSize: "16px" }}> To </span>
                          </th>
                        </tr>

                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Origin location</span>
                          </th>
                          <td>
                            <span>
                              {" "}
                              {relocationDetail.origin_city1} ,{" "}
                              {relocationDetail.origin_state1},
                              {relocationDetail.origin_country1}{" "}
                            </span>
                          </td>
                          <th>
                            <span>Destination location</span>
                          </th>
                          <td>
                            <span>
                              {" "}
                              {relocationDetail.destination_city1} ,{" "}
                              {relocationDetail.destination_state1},
                              {relocationDetail.destination_country1}{" "}
                            </span>
                          </td>
                        </tr>

                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Pickup Address</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                type="text"
                                value={orderDetail.origin_address}
                                name="origin_address"
                                onChange={handleODChange}
                                style={inputStyle}
                              />
                            ) : (
                              <span>{orderDetail.origin_address}</span>
                            )}
                          </td>

                          <th>
                            <span>Drop Address</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                type="text"
                                value={orderDetail.destination_address}
                                name="destination_address"
                                onChange={handleODChange}
                                style={inputStyle}
                              />
                            ) : (
                              <span>{orderDetail.destination_address}</span>
                            )}
                          </td>
                        </tr>

                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Origin Pincode</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                type="text"
                                value={orderDetail.origin_pin}
                                name="origin_pin"
                                onChange={handleODChange}
                                style={inputStyle}
                              />
                            ) : (
                              <span>{orderDetail.origin_pin}</span>
                            )}
                          </td>
                          <th>
                            <span>Destination Pincode</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                type="text"
                                value={orderDetail.destination_pin}
                                name="destination_pin"
                                onChange={handleODChange}
                                style={inputStyle}
                              />
                            ) : (
                              <span>{orderDetail.destination_pin}</span>
                            )}
                          </td>
                        </tr>

                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Sender's Name</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                type="text"
                                value={orderDetail.origin_contact_person}
                                name="origin_contact_person"
                                onChange={handleODChange}
                                style={inputStyle}
                              />
                            ) : (
                              <span>{orderDetail.origin_contact_person}</span>
                            )}
                          </td>
                          <th>
                            <span>Receiver's Name</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                type="text"
                                value={orderDetail.destination_contact_person}
                                name="destination_contact_person"
                                onChange={handleODChange}
                                style={inputStyle}
                              />
                            ) : (
                              <span>{orderDetail.destination_contact_person}</span>
                            )}
                          </td>
                        </tr>

                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Sender's Contact</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                type="text"
                                value={orderDetail.sender_contact_no}
                                name="sender_contact_no"
                                onChange={handleODChange}
                                style={inputStyle}
                              />
                            ) : (
                              <span>{orderDetail.sender_contact_no}</span>
                            )}
                          </td>
                          <th>
                            <span>Receiver's Contact</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                type="text"
                                value={orderDetail.receiver_contact_no}
                                name="receiver_contact_no"
                                onChange={handleODChange}
                                style={inputStyle}
                              />
                            ) : (
                              <span>{orderDetail.receiver_contact_no}</span>
                            )}
                          </td>
                        </tr>

                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Sender's Alternate Contact</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                value={orderDetail.sender_alternate_no}
                                type="text"
                                name="sender_alternate_no"
                                onChange={handleODChange}
                                style={inputStyle}
                              />
                            ) : (
                              <span>{orderDetail.sender_alternate_no}</span>
                            )}
                          </td>
                          <th>
                            <span>Receiver's Alternate Contact</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                value={orderDetail.receiver_alternate_no}
                                type="text"
                                name="receiver_alternate_no"
                                onChange={handleODChange}
                                style={inputStyle}
                              />
                            ) : (
                              <span>{orderDetail.receiver_alternate_no}</span>
                            )}
                          </td>
                        </tr>

                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Sender's Email id</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                type="text"
                                value={orderDetail.sender_alternate_email}
                                name="sender_alternate_email"
                                onChange={handleODChange}
                                style={inputStyle}
                              />
                            ) : (
                              <span>{orderDetail.sender_alternate_email}</span>
                            )}
                          </td>
                          <th>
                            <span>Receiver's Email id</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                value={orderDetail.receiver_alternate_email}
                                type="text"
                                name="receiver_alternate_email"
                                onChange={handleODChange}
                                style={inputStyle}
                              />
                            ) : (
                              <span>{orderDetail.receiver_alternate_email}</span>
                            )}
                          </td>
                        </tr>
                      </table>
                      {/* </div>
                    <div className="viewLeadDetails-form"> */}
                      <table
                        style={{
                          width: "100%",
                          color: "#6A6A6A",
                          borderRadius: "5px",
                        }}
                      >
                        {/* <tr className="viewLeadDetailsHeading">
                          <th colSpan={4}>
                            <span style={{ fontSize: "18px" }}> </span>
                          </th>
                        </tr>*/}
                        <tr
                          className="viewLeadDetailsHeading"
                          style={{ height: "3px" }}
                        >
                          <td colSpan={4}></td>
                        </tr>

                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Pick-up Distance</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                value={orderDetail.pick_up_distance}
                                type="text"
                                name="pick_up_distance"
                                onChange={handleODChange}
                                style={inputStyle}
                              />
                            ) : (
                              <span>{orderDetail.pick_up_distance}</span>
                            )}
                          </td>
                          <th>
                            <span>Drop distance</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                value={orderDetail.drop_distance}
                                type="text"
                                name="drop_distance"
                                onChange={handleODChange}
                                style={inputStyle}
                              />
                            ) : (
                              <span>{orderDetail.drop_distance}</span>
                            )}
                          </td>
                        </tr>

                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Relocation Stage</span>
                          </th>
                          <td>
                            <span>
                              {relocationStageString}- {relocationSubStageString}{" "}
                            </span>
                          </td>
                          <th>
                            <span>Status</span>
                          </th>
                          <td>
                            <span>{orderStatusString}</span>
                          </td>
                        </tr>
                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Selected Slot</span>
                          </th>
                          <td>
                            <span>{ }</span>
                          </td>
                          <th>
                            <span>Mode Of Transportation</span>
                          </th>
                          <td>
                            <span>{ }</span>
                          </td>
                        </tr>
                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>From Airport</span>
                          </th>
                          <td>
                            <span>{ }</span>
                          </td>
                          <th>
                            <span>To Airport</span>
                          </th>
                          <td>
                            <span>{ }</span>
                          </td>
                        </tr>
                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Airline Name</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                type="text"
                                name="airline_train_name"
                                onChange={handleODChange}
                                style={inputStyle}
                              />
                            ) : (
                              <span>{orderDetail.airline_train_name}</span>
                            )}
                          </td>
                          <th>
                            {" "}
                            <span>Flight Number</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                value={orderDetail.airline_train_number}
                                type="text"
                                name="airline_train_number"
                                onChange={handleODChange}
                                style={inputStyle}
                              />
                            ) : (
                              <span>{orderDetail.airline_train_number}</span>
                            )}
                          </td>
                        </tr>
                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>departure Time(Estimate)</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                style={{ margin: "0px", ...inputStyle }}
                                className="form-control"
                                type="date"
                                name="departure_time"
                                placeholder="Please Enter*"
                                onChange={handleODChange}
                                value={orderDetail.departure_time}
                              />
                            ) : (
                              <span>{orderDetail.departure_time}</span>
                            )}
                          </td>
                          <th>
                            <span>Arrival Time(Estimate)</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                style={{ margin: "0px", ...inputStyle }}
                                className="form-control"
                                type="date"
                                name="arrival_time"
                                placeholder="Please Enter*"
                                onChange={handleODChange}
                                value={orderDetail.arrival_time}
                              />
                            ) : (
                              <span>{orderDetail.arrival_time}</span>
                            )}
                          </td>
                        </tr>

                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Shipment Reference Number</span>
                          </th>
                          <td>
                            {isEditMode ? (
                              <input
                                type="text"
                                name="awb_number"
                                placeholder="Please Enter*"
                                onChange={handleAWBChange}
                                value={leadDetailResponse.awb_number || ""}
                                style={inputStyle}
                              />
                            ) : (
                              <span>{leadDetailResponse.awb_number}</span>
                            )}
                          </td>
                          <th colSpan={2}>

                          </th>

                        </tr>



                      </table>
                    </div>

                    {/* Relocation Details  */}

                    {/* Pet Details */}
                    <div className="viewOrderDetails-form">
                      <table
                        style={{
                          width: "100%",
                          color: "#6A6A6A",
                          borderRadius: "5px",
                        }}
                      >
                        <tr className="viewLeadDetailsHeading">
                          <th
                            colSpan={4}
                            style={{
                              background: "#5B489D",
                              color: "white",
                              fontWeight: "bold",
                            }}
                          >
                            <span style={{ fontSize: "18px", paddingTop: "1rem" }}>
                              {" "}
                              Pet Detail{" "}
                            </span>
                          </th>
                        </tr>
                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Number Of Pet</span>
                          </th>
                          <td>
                            <span>{leadDetailResponse.number_of_pets}</span>
                          </td>
                          <th>
                            <span>Pet Type & Breed</span>
                          </th>
                          <td>
                            <span>
                              {petDetail.pettype},{petDetail.petbreedtype}
                            </span>
                          </td>
                        </tr>

                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Pet Name</span>
                          </th>
                          <td>
                            <span>{petDetail.pet_name}</span>
                          </td>
                          <th>
                            <span>Pet Gender</span>
                          </th>
                          <td>
                            <span>{petDetail.pet_gender}</span>
                          </td>
                        </tr>

                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Pet DOB | Pet Age</span>
                          </th>
                          <td>
                            <span>
                              {petDetail.pet_dob}, {petDetail.pet_age}
                            </span>
                          </td>
                          <th>
                            <span>Pet Weight</span>
                          </th>
                          <td>
                            <span>{petDetail.pet_weight}</span>
                          </td>
                        </tr>

                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Pet Behaviour</span>
                          </th>
                          <td>
                            <span>{petDetail.pet_behaviour}</span>
                          </td>

                          <th>
                            <span>Pet colour</span>
                          </th>
                          <td>
                            <span>{ }</span>
                          </td>
                        </tr>

                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Pet Measurement(A,B,C&D)</span>
                          </th>
                          <td>
                            <span>
                              {petDetail.pet_length},{petDetail.container_length},
                              {petDetail.pet_width}&{petDetail.pet_height}
                            </span>
                          </td>

                          <th>
                            <span>-</span>
                          </th>
                          <td>
                            <span>-</span>
                          </td>
                        </tr>
                      </table>
                    </div>

                    {/* Pet Details */}

                    {/* ----------------------------Pet images------------------------------------------------ */}
                    <br />
                    <br />
                    <div className="viewLeadDetails-form">
                      <table
                        style={{
                          width: "100%",
                          color: "#6A6A6A",
                          borderRadius: "5px",
                        }}
                      >
                        <tr className="viewLeadDetailsHeading">
                          <th
                            colSpan={2}
                            style={{
                              background: "#5B489D",
                              color: "white",
                              fontWeight: "bold",
                            }}
                          >
                            <span style={{ fontSize: "16px" }}>
                              {" "}
                              Pet related Pictures{" "}
                            </span>
                          </th>
                        </tr>
                        <tr
                          className="viewLeadDetailsHeading"
                          style={{ height: "20px", border: "none" }}
                        >
                          <th
                            colSpan={2}
                            style={{
                              background: "#FFFFFF",
                              border: "none",
                            }}
                          ></th>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", padding: "0px 10px 10px 10px" }}>
                            <div
                              style={{
                                border: "1px solid #DEE2E6",
                                // borderRadius: "1rem",
                              }}
                            >
                              <div className="pet-image-text-1">
                                <h5>Vaccination Book</h5>
                              </div>
                              <table style={{ width: "100%" }}>
                                <tr>
                                  <td style={{ height: "11rem", width: "50%" }}>
                                    <img
                                      alt="vaccination Book Front"
                                      src={petDetail.vaccinationBookFront}
                                      style={{
                                        width: "100%",
                                        height: "16.25rem",
                                        cursor: "pointer",
                                        paddingLeft: "1rem",
                                        paddingBottom: "1rem",
                                      }}
                                    />
                                  </td>
                                  <td style={{ height: "11rem", width: "50%" }}>
                                    <img
                                      alt="vaccination Book Back"
                                      src={petDetail.vaccinationBookBack}
                                      style={{
                                        width: "100%",
                                        height: "16.25rem",
                                        cursor: "pointer",
                                        paddingBottom: "1rem",
                                        paddingRight: "1rem",
                                      }}
                                    />
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </td>
                          <td style={{ width: "50%", padding: "0 10px 0px 1px" }}>
                            <div
                              style={{
                                border: "1px solid #DEE2E6",
                                // borderRadius: "1rem",
                              }}
                            >
                              <h5 className="pet-image-text-2">Pet Photos</h5>
                              <table style={{ width: "100%" }}>
                                <tr>
                                  <td style={{ height: "11rem", width: "50%" }}>
                                    <img
                                      alt="pet Photos Standing"
                                      src={petDetail.pet_photo_standing}
                                      style={{
                                        width: "100%",
                                        height: "16.25rem",
                                        cursor: "pointer",
                                        paddingBottom: "1rem",
                                      }}
                                    />
                                  </td>
                                  <td style={{ height: "11rem", width: "50%" }}>
                                    <img
                                      alt="pet Photos Sitting"
                                      src={petDetail.pet_photo_sitting}
                                      style={{
                                        width: "100%",
                                        height: "16.25rem",
                                        cursor: "pointer",
                                        paddingBottom: "1rem",
                                        paddingRight: "1rem",
                                      }}
                                    />
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    {/*----------------------------- Pet Img--------------------------------*/}
                  </div>
                </Wrapper>
                <br />

                <Wrapper className="LeadDetails">
                  {/* ----------------------------------Upload Documents-------------------------------------- */}

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                    }}
                  >
                    <div className="viewLeadDetails-form" style={{ border: "none" }}>
                      <table
                        style={{
                          width: "100%",
                          color: "#6A6A6A",
                          borderRadius: "5px",
                        }}
                      >
                        <tr>
                          <td colSpan={4}>
                            <table style={{ width: "100%" }}>
                              <tr className="viewLeadDetailsHeading">
                                <th
                                  style={{
                                    background: "#5B489D",
                                    color: "white",
                                    fontWeight: "bold",
                                    width: "87%",
                                    borderRight: "1px solid white",
                                    borderTopRightRadius: "1px",
                                    borderBottomRightRadius: "1px",
                                  }}
                                >
                                  <span style={{ fontSize: "18px" }}>
                                    {" "}
                                    Upload Documents{" "}
                                  </span>
                                </th>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <th style={{ border: "none" }}>
                            <span>Choose Document</span>
                          </th>
                          <th style={{ border: "none" }}>
                            <span>Document Type</span>
                          </th>
                        </tr>
                        <tr>
                          <td>
                            <select
                              id="document_type"
                              className="form-control"
                              name="document_type"
                              onChange={handleChangeDoc}
                              value={documentsUpload.document_type}
                            >
                              <option value="0">Select an option</option>
                              {documentType.map((item, index) => (
                                <option key={index} value={item.Name} >{item.Name}</option>
                              ))}
                            </select>
                          </td>
                          <td>
                            <input
                              id="doc_name"
                              type="file"
                              name="doc_name"
                              onChange={handleChangeDoc}
                              ref={fileInputRef}
                              required
                              className="form-control"
                              style={{ width: "-webkit-fill-available" }}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th style={{ border: "none" }}>
                            <span> Any Remark</span>
                          </th>
                        </tr>
                        <tr>
                          <td>
                            <input
                              id="remarkDoc"
                              type="text"
                              name="remarkDoc"
                              onChange={handleChangeDoc}
                              value={documentsUpload.remarkDoc}
                              placeholder="Please Enter*"
                              className="form-control"
                              style={{ width: "175%" }}
                            />
                          </td>

                          <td style={{ textAlign: "end" }}>
                            <button
                              style={{
                                backgroundColor: "#5B489D",
                                color: "white",
                                width: "21%",
                                margin: "7px",
                              }}
                              className="btn btn-success inputDoc3"
                              onClick={uploadDocument}
                            >
                              Upload
                            </button>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <br />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                    }}
                  >
                    <div className="viewLeadDetails-form">
                      <table
                        style={{
                          width: "100%",
                          color: "#6A6A6A",
                          borderRadius: "5px",
                        }}
                      >
                        <tr>
                          <td colSpan={4}>
                            <table style={{ width: "100%" }}>
                              <tr className="viewLeadDetailsHeading">
                                <th
                                  style={{
                                    background: "#5B489D",
                                    color: "white",
                                    fontWeight: "bold",
                                    width: "87%",
                                    borderRight: "1px solid white",
                                    borderTopRightRadius: "1px",
                                    borderBottomRightRadius: "1px",
                                  }}
                                >
                                  <span style={{ fontSize: "18px" }}>
                                    {" "}
                                    Documents{" "}
                                  </span>
                                </th>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Customer Name</span>
                          </th>
                          <td>
                            <span>{leadDetailResponse.first_name}</span>
                          </td>
                          <th>
                            <span>Lead Owner</span>
                          </th>
                          <td>
                            <span>{leadDetailResponse.name}</span>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <div
                    style={{
                      width: "100%",
                      // maxHeight: "300px",
                      // overflowY: "scroll",
                      alignItems: "center",
                    }}
                  >
                    <table
                      className="customerDetailsTable"
                      style={{ width: "99%", marginLeft: "5px" }}
                    >
                      <div className=" undefined" style={{ width: "100%" }}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <div
                            style={{
                              padding: "11px 0 0 0",


                            }}
                          >
                            {loading ? (
                              <div style={{ position: "relative", left: "540px" }}>
                                <Loader />
                              </div>
                            ) : (
                              <table>
                                <tr className="docUpload">
                                  <th>Sr No.</th>
                                  <th
                                    onClick={() => sortAndToggleOrder("document_type")}>Document Type
                                    {sortedColumn === "document_type" && (
                                      <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                                    )}</th>
                                  <th>Upload Date and Time</th>
                                  <th>Uploaded By</th>
                                  <th>Remark</th>
                                  <th>Review</th>
                                  <th>Submit</th>
                                </tr>
                                {documentResponse !== null
                                  ? documentResponse.map((item, index) => (
                                    <tr className="documentTable">
                                      <td style={{ width: "5%" }}>{++index}</td>
                                      <td style={{ width: "20%" }}>
                                        {item.document_type}
                                      </td>
                                      <td>
                                        {new Date(item.created_date).toLocaleString(
                                          "en-US",
                                          {
                                            month: "short", // Oct
                                            day: "numeric", // 23
                                            year: "numeric", // 2024
                                            hour: "numeric", // 11
                                            minute: "numeric", // 22
                                            hour12: true, // AM/PM format
                                          }
                                        )}
                                      </td>
                                      <td style={{ width: "15%" }}>
                                        {item.added_by}
                                      </td>

                                      <td style={{ width: "20%" }}>
                                        {item.remarkDoc}
                                      </td>
                                      <td style={{ width: "20%" }}>
                                        <a
                                          style={{
                                            color: "#6a6a6a",
                                            textDecoration: "none",
                                            cursor: "pointer",
                                            fontWeight: "bold",
                                          }}
                                          target="_blank"
                                          href={`${baseImageURL}Images/Documents/${item.relocation_id}/${item.doc_name}`}
                                          rel="noopener noreferrer"
                                        >
                                          <img src={search} alt="search" />
                                        </a>

                                        {/* {item.isSubmit === 0 || isAdmin === "true" ? (

                                          <button
                                            onClick={() =>
                                              deleteDoc(item.client_doc_id)
                                            }
                                            style={{
                                              height: "35px",
                                              width: "35px",
                                              marginLeft: "5px",
                                              backgroundColor: "#F4616F",
                                              borderColor: "#FF0000",
                                            }}
                                          >
                                            <DeleteOutlinedIcon className="icon" />
                                          </button>
                                        ) : null} */}

                                        {relocationSubStageString !== "File submitted to the finance" && (
                                          <button
                                            onClick={() =>
                                              deleteDoc(item.client_doc_id)
                                            }
                                            style={{
                                              height: "35px",
                                              width: "35px",
                                              marginLeft: "5px",
                                              backgroundColor: "#F4616F",
                                              borderColor: "#FF0000",
                                            }}
                                          >
                                            <DeleteOutlinedIcon className="icon" />
                                          </button>
                                        )}
                                      </td>
                                      <td>
                                        {item.isSubmit === 0 ? (

                                          <button
                                            style={{
                                              backgroundColor: "#DD4477",
                                              color: "white",
                                              width: "82%",
                                              margin: "7px",
                                              fontWeight: "bold"

                                            }}
                                            className="btn btn-success inputDoc3"
                                            onClick={() =>
                                              submitDocument(item.client_doc_id)
                                            }
                                          >
                                            Submit
                                          </button>
                                        ) :
                                          (
                                            <button
                                              style={{
                                                backgroundColor: "#04B35A",
                                                color: "white",
                                                width: "82%",
                                                margin: "7px",
                                                fontWeight: "bold",
                                                cursor: "default"
                                              }}
                                              className="btn btn-success inputDoc3"
                                            >
                                              Submitted
                                            </button>
                                          )}
                                      </td>
                                    </tr>
                                  ))
                                  : null}
                              </table>
                            )}
                          </div>
                        </div>
                      </div>
                    </table>
                  </div>
                </Wrapper>
                <br />

                <Wrapper className="LeadDetails">
                  {/* ----------------------------------Update Lead Information-------------------------------------- */}

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                    }}
                  >
                    <div className="viewLeadDetails-form">
                      <table
                        style={{
                          width: "100%",
                          color: "#6A6A6A",
                          borderRadius: "5px",
                        }}
                      >
                        <tr>
                          <td colSpan={4}>
                            <table style={{ width: "100%" }}>
                              <tr className="viewLeadDetailsHeading">
                                <th
                                  style={{
                                    background: "#5B489D",
                                    color: "white",
                                    fontWeight: "bold",
                                    width: "87%",
                                    borderRight: "1px solid white",
                                    borderTopRightRadius: "1px",
                                    borderBottomRightRadius: "1px",
                                  }}
                                >
                                  <span style={{ fontSize: "18px" }}>
                                    {" "}
                                    Update Order Information{" "}
                                  </span>
                                </th>

                                <th
                                  style={{
                                    background: "#5B489D",
                                    color: "white",
                                    fontWeight: "bold",
                                    width: "12%",
                                    borderLeft: "1px solid white",
                                    borderTopLeftRadius: "1px",
                                    borderBottomLeftRadius: "1px",
                                  }}
                                >
                                  <span>
                                    Total Remarks -{" "}
                                    {orderUpdateList && orderUpdateList.length
                                      ? orderUpdateList.length
                                      : 0}
                                  </span>
                                </th>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Next Follow-up Date/Time</span>
                          </th>
                          <td>
                            <input
                              className="form-control"
                              type="datetime-local"
                              name="nextfollowupdatetime"
                              value={orderUpdate.nextfollowupdatetime}
                              placeholder="Please Enter*"
                              onChange={handleChange}
                            />
                          </td>
                          {/* <th>
                      <span>Order Can View</span>
                    </th>
                    <td>
                      <select
                        className="form-control"
                        disabled
                      >
                        <option value="0">Select an option</option>
                      </select>
                    </td> */}

                          <th>
                            <span>Order Stage</span>
                          </th>
                          <td>
                            <select
                              className="form-control"
                              name="order_status"
                              value={orderUpdate.order_status}
                              onChange={handleChange}
                              style={inputStyle}
                            >
                              <option value="0">Select an option</option>

                              {orderStatus?.map((item) => {
                                const isB2B = leadDetailResponse.customer_type === "B2B";

                                // Convert Payment_Ter string → number
                                const paymentTer = Number(leadDetailResponse.paymentDetail?.[0]?.Payment_Ter);

                                const disableOrder2 =
                                  !isB2B && item.order_id === 2 && !(paymentTer > 99.5);

                                return (
                                  <option
                                    key={item.order_id}
                                    value={item.order_id}
                                    disabled={disableOrder2}
                                  >
                                    {item.order_status}
                                  </option>
                                );
                              })}
                            </select>
                          </td>
                        </tr>

                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Order Assign To</span>
                          </th>
                          <td>
                            <div style={{ display: "flex", alignItems: "center" }}                                                            >
                              <select
                                style={{
                                  width: "100%",
                                  maxWidth: "24rem",
                                  marginRight: "1rem",
                                }}
                                className="form-control"
                                name="assignTo"
                                value={orderUpdate.assignTo}
                                onChange={handleChange}
                                disabled={!isAdmin}
                              >
                                <option value="0">Select an option</option>
                                {assignToResponse !== null ? (
                                  assignToResponse.map((item) => (
                                    <option value={item.email}>{item.name}</option>
                                  ))
                                ) : (
                                  <p>empty</p>
                                )}
                              </select>
                              <button
                                style={{
                                  height: "38px",
                                  width: "98px",
                                  marginLeft: "1rem",
                                }}
                                onClick={ChangeLeadOwner}
                              >
                                Done
                              </button>
                            </div>
                          </td>
                          <th>
                            <span>Relocation Stage</span>
                          </th>
                          <td>
                            <select
                              className="form-control"
                              name="relocation_stage"
                              value={orderUpdate.relocation_stage}
                              onChange={handleChange}
                            >
                              <option value="0">Select an option</option>
                              {relocationStage !== null ? (
                                relocationStage.map((item) => (
                                  <option key={item.stage_id} value={item.stage_id}>
                                    {item.relocation_stage}
                                  </option>
                                ))
                              ) : (
                                <option disabled>Loading...</option>
                              )}
                            </select>
                          </td>
                        </tr>

                        <tr className="viewLeadDetailsHeading">
                          <th style={{ width: "26%" }}>
                            <span>Assign Field Ops</span>
                          </th>
                          <td>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <Multiselect
                                className="multiselect-change-placeholder"
                                options={fieldOps}
                                selectedValues={selectedAssignedTo}
                                onSelect={onSelect}
                                onRemove={onRemove}
                                displayValue="name"
                                placeholder="Select Field Ops"
                              />
                            </div>
                          </td>
                          <th>
                            <span>Relocation Sub-Stage</span>
                          </th>
                          <td>
                            <select
                              className="form-control"
                              name="relocation_substage"
                              value={orderUpdate.relocation_substage}
                              onChange={handleChange}
                            >
                              <option value="0">Select an option</option>
                              {relocationSubStage !== null ? (
                                relocationSubStage.map((item) => (
                                  <option
                                    key={item.substage_id}
                                    value={item.substage_id}
                                  >
                                    {item.sub_stage_name}
                                  </option>
                                ))
                              ) : (
                                <option disabled>Loading...</option>
                              )}
                            </select>
                          </td>
                        </tr>
                        <tr className="viewLeadDetailsHeading">
                          <th>
                            <span>Remark</span>
                          </th>
                          <td colSpan={3}>
                            <input
                              style={{ width: "99%", ...inputStyle }}
                              className="form-control"
                              type="text"
                              name="remark"
                              value={orderUpdate.remark}
                              placeholder="Please Enter*"
                              onChange={handleChange}
                            />
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <br />

                  <h3
                    style={{
                      marginTop: "1rem",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    {" "}
                    Remark Timeline
                  </h3>
                  <div
                    style={{
                      width: "100%",
                      maxHeight: "300px",
                      overflowY: "scroll",
                      alignItems: "center",
                    }}
                  >
                    <table
                      className="customerDetailsTable"
                      style={{ width: "99%", marginLeft: "5px" }}
                    >
                      {orderUpdateList?.map((remark, index) => (
                        <div className="wrapper undefined" style={{ width: "100%" }}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              margin: "1rem",
                              padding: "1rem",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                              }}
                            >
                              <h3 className="card-title">
                                <b>
                                  Remark{" "}
                                  {orderUpdateList && orderUpdateList.length
                                    ? orderUpdateList.length - index
                                    : 0}
                                </b>{" "}
                              </h3>
                              <p className="card-text">
                                {" "}
                                <b> {remark.followUpDate} </b>{" "}
                              </p>
                            </div>
                            <div className="row" style={{ padding: "11px 0 0 0" }}>
                              <div className="col-3">
                                <div className="card" style={{ width: "100%" }}>
                                  <div className="card-body">
                                    <p className="card-text">
                                      <b>Order Status and Stage: &nbsp;</b>
                                      <span>{remark.order_status_name}</span>

                                      <span style={{ fontWeight: "bold" }}>
                                        - {remark.relocation_stage_name} -{" "}
                                        {remark.sub_stage_name}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="col-3">
                                <div className="card" style={{ width: "100%" }}>
                                  <div className="card-body">
                                    <p className="card-text">
                                      <b>Order Owner - </b>
                                      <span>{remark.assigned_name}</span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="col-3">
                                <div className="card" style={{ width: "100%" }}>
                                  <div className="card-body">
                                    <p className="card-text">
                                      <b>Field Ops - </b>
                                      <span>{remark.assign_to_field_ops}</span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="col-3">
                                <div className="card" style={{ width: "100%" }}>
                                  <div className="card-body">
                                    <p className="card-text">
                                      <b>Next Follow Up Date/Time - </b>
                                      <span>{remark.NextFollowupDateTime}</span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="row"
                              style={{ padding: "11px 0 0 0", border: "none" }}
                            >
                              <div className="col-12">
                                <div
                                  className="card"
                                  style={{
                                    width: "100%",
                                    boeder: "none",
                                    background: "none",
                                  }}
                                >
                                  <div className="card-body">
                                    <p
                                      className="card-text"
                                      style={{
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {remark.remark}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </table>
                  </div>
                </Wrapper>
                <br />

                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div>
                    {relocationSubStageString !== "File submitted to the finance" && (
                      <button
                        style={{
                          marginTop: "10px",
                          background: `linear-gradient(to right, ${gradientColors.join(
                            ", "
                          )})`,
                          color: "white",
                        }}
                        onClick={handleSubmit}
                      >
                        Update
                      </button>
                    )}
                  </div>

                  {/* <div style={{ position: "relative", cursor: "pointer" }}>
                    <img
                      style={{ width: "160px", height: "53px", marginTop: "10px" }}
                      src={reactangle}
                      alt="rectangle"
                    />
                    <img
                      style={{ position: "absolute", top: 18, left: 20 }}
                      src={nextstep}
                      alt="next step"
                    />
                  </div> */}
                </div>
              </div>
            </div>
          )}
          {activeTab === "Scope Of Work" && (
            <PaymentDetails Relocation_Id={Relocation_ID} />

          )}

          {activeTab === "Execution & Documentation" && (

            <ExecutionDOc Relocation_Id={Relocation_ID} />

          )}

          {activeTab === "Expense List" && (
            <LeadExpenseListView relocationId={Relocation_ID} />
          )}

          {activeTab === "Payment Details" && (
            <LeadPaymentDetails Relocation_Id={Relocation_ID} isEditMode={isEditMode} setIsEditMode={setIsEditMode} module="ops" />
          )}

        </div>
      </div >
    </div >
  );
};

export default ViewOrderDetails;
